export { View as ViewActionPathPage } from './View';
